import api from './api';
import { Receivable, ReceivableHistory, ReceivableDashboard } from '../types';

export const receivableService = {
  /**
   * Listar todas as parcelas com filtros
   */
  async getAll(params?: {
    status?: string;
    associate_id?: number;
    plan_id?: number;
    start_date?: string;
    end_date?: string;
    active?: boolean;
    search?: string;
    associate_name?: string;
    sort_by?: string;
    sort_order?: string;
    per_page?: number;
    page?: number;
  }) {
    const response = await api.get('/receivables', { params });
    return response.data;
  },

  /**
   * Obter detalhes de uma parcela
   */
  async getById(id: number): Promise<Receivable> {
    const response = await api.get(`/receivables/${id}`);
    return response.data;
  },

  /**
   * Criar nova parcela
   */
  async create(data: {
    associate_id: number;
    plan_id: number;
    due_date: string;
    amount: number;
    notes?: string;
  }): Promise<Receivable> {
    const response = await api.post('/receivables', data);
    return response.data;
  },

  /**
   * Baixar parcela (marcar como paga)
   */
  async markAsPaid(id: number, data?: {
    amount_paid?: number;
    payment_date?: string;
    notes?: string;
  }) {
    const response = await api.post(`/receivables/${id}/pay`, data);
    return response.data;
  },

  /**
   * Cancelar baixa de parcela
   */
  async cancelPayment(id: number, notes?: string) {
    const response = await api.post(`/receivables/${id}/cancel-payment`, { notes });
    return response.data;
  },

  /**
   * Inativar parcela
   */
  async inactivate(id: number, notes: string) {
    const response = await api.post(`/receivables/${id}/inactivate`, { notes });
    return response.data;
  },

  /**
   * Reativar parcela
   */
  async reactivate(id: number, notes?: string) {
    const response = await api.post(`/receivables/${id}/reactivate`, { notes });
    return response.data;
  },

  /**
   * Obter histórico de uma parcela
   */
  async getHistory(id: number): Promise<ReceivableHistory[]> {
    const response = await api.get(`/receivables/${id}/history`);
    return response.data;
  },

  /**
   * Obter estatísticas do dashboard
   */
  async getDashboard(params?: {
    start_date?: string;
    end_date?: string;
  }): Promise<ReceivableDashboard> {
    const response = await api.get('/receivables/dashboard', { params });
    return response.data;
  },

  /**
   * Obter parcelas do associado logado
   */
  async getMyReceivables(params?: {
    status?: string;
  }): Promise<Receivable[]> {
    const response = await api.get('/receivables/my-receivables', { params });
    return response.data;
  },
};
